module.exports = __webpack_public_path__ + "static/img/14000643.4b6d699c.png";